import { Button, Card } from "@postenbring/hedwig-react";
import { Icon } from "../../../shared/icon/icon";
import "./VideoOverlay.scss";

export const VideoOverlay = ({
  videoUrl,
  imageUrl,
  imageAltText,
  isIllustration,
  focalPointStyle,
}) => {
  return (
    <>
      <Card.Media>
        <div className="kp-card-video-overlay">
          <Button asChild>
            <a href={videoUrl}>
              <Icon variant="play" />
            </a>
          </Button>
        </div>
        <Card.MediaImg
          style={focalPointStyle}
          alt={!isIllustration ? imageAltText : ""}
          src={imageUrl}
          variant={isIllustration ? "scale" : undefined}
        />
      </Card.Media>
    </>
  );
};
